import { Col, Divider, Row, Tabs, } from "antd";

import FormLogin from './components/FormLogin';
import ButtonGoogle from './components/ButtonGoogle';
import PassRecovery from "./components/PasswordResetRequest";
import { useState } from "react";

export default function LoginEgresados() {
    const [activeTab, setActiveTab] = useState('1');

    const handleTabChange = async (key) => {
        setActiveTab(key);
    };

    const items = [
        {
            key: '1',
            label: 'Iniciar Sesión',
            children: <>
                <Row>
                    <Col span={24}>
                        <FormLogin />
                    </Col>
                    <Col span={24}>
                        <Divider> ó </Divider>
                    </Col>
                    <Col span={24}>
                        <ButtonGoogle />
                    </Col>
                </Row>
            </>,
        },
        {
            key: '2',
            label: 'Recuperar Contraseña',
            children: <>
                <PassRecovery
                    onTabChange={handleTabChange}
                />
            </>,
        },
    ];

    return (
        <>
            <Row>
                <Col span={24}>
                    <Tabs activeKey={activeTab} onChange={handleTabChange} items={items} />
                </Col>
            </Row>
        </>
    );
}